const StripeStatusEnum = Object.freeze({
  "NoPaymentMethod": 1,
  "ValidPaymentMethod": 2,
  "FailedPaymentMethod": 3
});

export default StripeStatusEnum;